import { render, staticRenderFns } from "./RequestDocumentTemplate.vue?vue&type=template&id=748a8953&"
import script from "./RequestDocumentTemplate.vue?vue&type=script&lang=js&"
export * from "./RequestDocumentTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('748a8953')) {
      api.createRecord('748a8953', component.options)
    } else {
      api.reload('748a8953', component.options)
    }
    module.hot.accept("./RequestDocumentTemplate.vue?vue&type=template&id=748a8953&", function () {
      api.rerender('748a8953', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/creationPages/RequestDocumentTemplate.vue"
export default component.exports